(() => {
  function initBulk() {
    document.querySelectorAll('[data-rwc-bulk]').forEach(root => {
      const form = document.getElementById(root.dataset.form);
      if (!form || root.dataset.ready) return;
      let data;
      try { data = JSON.parse(root.querySelector('[data-bulk-data]').textContent); }
      catch (_) { return; }
      const quantity = form.elements.quantity;
      const radios = [...root.querySelectorAll('[data-bulk-size]')];
      const offers = [...form.querySelectorAll('[data-rwc-upsell]')];
      const accelerated = form.querySelector('[data-rwc-accelerated]');
      const buttons = [...form.querySelectorAll('button[type="submit"]')];
      const error = root.querySelector('[data-bulk-error]');
      const quantityLabel = form.querySelector('label[for="' + quantity.id + '"]');
      let busy = false;
      let size = data.initialSize;
      let lastId = null;
      const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:data.currency}).format(amount / 100) + ' ' + data.currency;
      const selectedExtras = () => {
        const checked = kind => offers.some(o => o.dataset.addonKind === kind && o.querySelector('[data-puzzle-checkbox]').checked);
        const cal = checked('CAL'), puz = checked('PUZ');
        return cal && puz ? 'BOTH' : cal ? 'CAL' : puz ? 'PUZ' : 'NONE';
      };
      const selectionFor = (count, extras) => {
        const plan = data.plans.find(p => p.size === count);
        if (count > 1) {
          const variant = plan?.variants.find(v => v.extras === extras);
          return variant ? {variant,items:[{id:variant.id,quantity:1}],price:variant.price,exact:true,available:variant.available} : null;
        }
        if (extras === 'BOTH') {
          const variant=data.complete;
          return variant ? {variant,items:[{id:variant.id,quantity:1}],price:variant.price,exact:true,available:variant.available} : null;
        }
        const variant=plan?.variants.find(v => v.extras === 'NONE');
        if (!variant) return null;
        const addon=extras === 'CAL' ? data.calendar : extras === 'PUZ' ? data.puzzle : null;
        if(extras !== 'NONE' && !addon) return null;
        const saving = data.currency === 'GBP' ? (extras === 'CAL' ? 300 : extras === 'PUZ' ? 400 : 0) : 0;
        return {variant,items:[{id:variant.id,quantity:1},...(addon ? [{id:addon.id,quantity:1}] : [])],price:variant.price+(addon ? addon.price-saving : 0),exact:!addon || data.currency==='GBP',available:variant.available && (!addon || addon.available)};
      };
      function update() {
        const extras=selectedExtras(), selection=selectionFor(size,extras);
        const variant=selection?.variant;
        if(variant && variant.id !== lastId) {
          quantity.min=variant.min || 1;
          quantity.step=variant.step || 1;
          if(variant.max != null) quantity.max=variant.max; else quantity.removeAttribute('max');
          if(!quantity.checkValidity()) quantity.value=variant.min || 1;
          lastId=variant.id;
        }
        const sets=Number(quantity.value);
        const validQuantity=Number.isInteger(sets) && sets>0 && quantity.checkValidity();
        const totalCount=size*(validQuantity ? sets : 1);
        const names=[totalCount+' '+(totalCount===1?data.labels.planner:data.labels.planners)];
        if(extras==='CAL'||extras==='BOTH')names.push(totalCount+' '+(totalCount===1?data.labels.calendar:data.labels.calendars));
        if(extras==='PUZ'||extras==='BOTH')names.push(totalCount+' '+(totalCount===1?data.labels.puzzle:data.labels.puzzles));
        root.querySelector('[data-bulk-contents]').textContent=names.join(' + ');
        root.querySelector('[data-bulk-total]').textContent=selection && selection.available
          ? (selection.exact ? data.labels.total : data.labels.before)+': '+money(selection.price*(validQuantity?sets:1))
          : data.labels.unavailable;
        root.querySelector('[data-bulk-note]').textContent=selection?.exact ? data.labels.saving : data.labels.converted;
        root.querySelectorAll('[data-bulk-option-price]').forEach(el=>{
          const option=selectionFor(Number(el.dataset.bulkOptionPrice),extras);
          el.textContent=option?.available ? money(option.price)+(option.exact?'':' · '+data.labels.before) : data.labels.unavailable;
        });
        if(quantityLabel) quantityLabel.textContent=size>1?data.labels.packQuantity:data.labels.quantity;
        if(accelerated) accelerated.hidden=!selection || selection.items.length>1 || selection.variant.id!==data.originalId || !selection.available;
        buttons.forEach(button=>{
          button.disabled=busy || !selection?.available || !validQuantity;
          button.textContent=busy?data.labels.checking:selection?.available?data.labels.add+' →':data.labels.unavailable;
        });
        return {selection,sets};
      }
      offers.forEach(offer=>{
        const checkbox=offer.querySelector('[data-puzzle-checkbox]');
        if(data.initialExtras!=='NONE') checkbox.checked=data.initialExtras==='BOTH'||data.initialExtras===offer.dataset.addonKind;
        offer.classList.add('rwc-upsell-ready');
        checkbox.addEventListener('change',()=>{error.hidden=true;update();});
      });
      radios.forEach(radio=>radio.addEventListener('change',()=>{
        if(!radio.checked)return;
        size=Number(radio.value);
        quantity.value='1';
        error.hidden=true;
        update();
      }));
      quantity.addEventListener('input',update);
      quantity.addEventListener('change',update);
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        if(busy || !form.reportValidity())return;
        const {selection,sets}=update();
        if(!selection?.available)return;
        busy=true;
        error.hidden=true;
        update();
        form.setAttribute('aria-busy','true');
        const controls=[...radios,quantity,...offers.map(o=>o.querySelector('[data-puzzle-checkbox]'))];
        controls.forEach(control=>control.disabled=true);
        try {
          const response=await fetch(root.dataset.add,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:selection.items.map(item=>({...item,quantity:item.quantity*sets}))})});
          const result=await response.json();
          if(!response.ok || result.status>=400)throw new Error();
          window.location.assign(root.dataset.cart);
        } catch (_) {
          error.textContent=data.labels.error;
          error.hidden=false;
        } finally {
          busy=false;
          controls.forEach(control=>control.disabled=false);
          form.removeAttribute('aria-busy');
          update();
        }
      });
      root.querySelector('[data-bulk-enhanced]').hidden=false;
      const nativeVariants=form.closest('.product-info')?.querySelector('[data-rwc-native-variants]');
      if(nativeVariants)nativeVariants.hidden=true;
      form.dataset.rwcOffersReady='true';
      root.dataset.ready='true';
      update();
    });
  }
  initBulk();
  document.addEventListener('shopify:section:load',initBulk);
})();

(() => {
function init(){
const groups=new Map();
document.querySelectorAll('[data-rwc-upsell]').forEach(o=>{
const f=document.getElementById(o.dataset.form);if(!f)return;
o.classList.add('rwc-upsell-ready');
if(!groups.has(f))groups.set(f,[]);groups.get(f).push(o);
});
groups.forEach((offers,form)=>{
if(form.dataset.rwcOffersReady)return;form.dataset.rwcOffersReady='true';
const selected=()=>offers.filter(o=>o.querySelector('[data-puzzle-checkbox]').checked);
const accelerated=form.querySelector('[data-rwc-accelerated]');
const complete=form.querySelector('[data-rwc-complete]');
const update=()=>{const count=selected().length;if(accelerated)accelerated.hidden=count>0;if(complete)complete.hidden=count!==2;};
offers.forEach(o=>o.querySelector('[data-puzzle-checkbox]').addEventListener('change',update));update();
let busy=false;
form.addEventListener('submit',async event=>{
const chosen=selected();if(!chosen.length)return;
event.preventDefault();if(busy||!form.reportValidity())return;
const quantity=Number(form.elements.quantity?.value||1);if(!Number.isInteger(quantity)||quantity<1)return;
busy=true;
const buttons=[...form.querySelectorAll('button[type="submit"]')];buttons.forEach(b=>b.disabled=true);
offers.forEach(o=>o.querySelector('[data-puzzle-error]').hidden=true);
form.setAttribute('aria-busy','true');
try{
if(chosen.length===2&&(!complete||complete.dataset.available!=='true')){
const error=chosen[0].querySelector('[data-puzzle-error]');
error.textContent=complete?.dataset.unavailable||chosen[0].dataset.error;
error.hidden=false;return;
}
const items=chosen.length===2
?[{id:complete.dataset.variantId,quantity}]
:[{id:form.elements.id.value,quantity},...chosen.map(o=>({id:o.dataset.addonId,quantity}))];
const response=await fetch(chosen[0].dataset.add,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
const data=await response.json();if(!response.ok||data.status>=400)throw new Error();
window.location.assign(chosen[0].dataset.cart);
}catch(e){const error=chosen[0].querySelector('[data-puzzle-error]');error.textContent=chosen[0].dataset.error;error.hidden=false;}
finally{busy=false;buttons.forEach(b=>b.disabled=false);form.removeAttribute('aria-busy');}
});
});
}
init();document.addEventListener('shopify:section:load',init);
})();